import { Filter, IsFilterable } from "@/lib/filterable";
import {
  MrfiktivCreateSignDtoGen,
  MrfiktivPopulatedSnapshotSignRequestViewModelGen
} from "@/services/mrfiktiv/v1/data-contracts";
import { SnapshotSignRequestBase } from "./snapshot-sign-request.entity";
import { ISnapshot, Snapshot } from "./snapshot.entity";
import snapshotSignResponseService from "@/services/mrfiktiv/services/snapshot-sign-response.service";

@IsFilterable
export class PopulatedSnapshotSignRequestBase extends SnapshotSignRequestBase
  implements MrfiktivPopulatedSnapshotSignRequestViewModelGen {
  snapshot: ISnapshot;

  constructor(obj?: Partial<MrfiktivPopulatedSnapshotSignRequestViewModelGen>) {
    super(obj);

    this.snapshot = new Snapshot(obj?.snapshot);
  }

  map(obj: MrfiktivPopulatedSnapshotSignRequestViewModelGen): void {
    super.map(obj);

    if (obj.snapshot) {
      this.snapshot.map(obj.snapshot);
    }
  }

  async respondAccept(dto: MrfiktivCreateSignDtoGen, token: string): Promise<void> {
    const updated = await snapshotSignResponseService.respondAccept(this.partnerId, this.id, token, dto);

    this.map(updated);
  }
}

type IPopulatedSnapshotSignRequest = PopulatedSnapshotSignRequestBase;
const PopulatedSnapshotSignRequest = Filter.createForClass(PopulatedSnapshotSignRequestBase);

export { IPopulatedSnapshotSignRequest, PopulatedSnapshotSignRequest };
